let apiPlantUuid = -1;

const ApiResultFlagsEnum = {
    isFlagged: 'isFlagged',
    isStruckOut: 'isStruckOut',
    isExpanded: 'isExpanded',
    isInFinalChain: 'isInFinalChain'
};

$(document).ready(function () {
    apiPlantUuid = getPlantUuid();
});

async function sendFlagState(resultId, flag, state) {
    return await sendResultFlags([{resultId: resultId, flags: [{flag: flag, state: state}]}]);
}

async function sendFlagStateMultiple(resultIds, flag, state) {
    let patchRequests = [];
    resultIds.forEach(function (resultId) {
        patchRequests.push({resultId: resultId, flags: [{flag: flag, state: state}]})
    });
    return await sendResultFlags(patchRequests);
}

async function sendResultFlags(resultFlags) {
    try {
        await $.ajax({
            url: `/api/plants/${apiPlantUuid}/search-results/set-flags`,
            type: 'PUT',
            data: {patchRequests: resultFlags},
        });
        return true;
    } catch (e) {
        console.log('Error while sending flag updates:', resultFlags, e);
    }
    return false;
}
